import React from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <NavLink
        to="/contact-us-details"
        className={({ isActive }) =>
          isActive ? "sidebar-card active" : "sidebar-card"
        }
      >
        <h6>Contact Us</h6>
        <p className="subtitle">View & manage contact enquiries</p>
      </NavLink>

      <NavLink
        to="/seo-enquiry-details"
        className={({ isActive }) =>
          isActive ? "sidebar-card active" : "sidebar-card"
        }
      >
        <h6>SEO Enquiries</h6>
        <p className="subtitle">SEO leads & enquiries</p>
      </NavLink>
    </aside>
  );
};

export default Sidebar;
